import React, { useState, forwardRef, useEffect, useRef } from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Button,
  Avatar,
  Card,
  CardMedia,
  CardContent,
  Stack,
  Slide,
  Snackbar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Swiper, SwiperSlide } from "swiper/react";
import PhotoIcon from "@mui/icons-material/Photo";
import TelegramIcon from '@mui/icons-material/Telegram';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import ReplyIcon from '@mui/icons-material/Reply';
import { convertSecondsToTime, formatViews, extractBlogger, parseTimestamp, parseStartAppParam, extractBloggerPhoto } from '../../funcs';
import "swiper/css";
import { DOMAIN, R2DOMAIN } from '../../config';
import SearchDialog from ".";
import VideoPlayerDialog from "../videoPlayerCard";
import { useUser } from "../../contexts/userContext";
import WindowIcon from "@mui/icons-material/Window";
import GameCategoryDialog from "../appDialog/type";
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import HomeIcon from '@mui/icons-material/Home';
import SaveTipsDialog from "./SaveTipsDialog";
import TopVideoDialog from "./topVideosDialog";
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import theme from '../../styles/theme';
import { useMediaQuery } from "@mui/material";
import TutorialVideoDialog from "./TutorialVideoDialog";
import DownloadIcon from '@mui/icons-material/Download';

dayjs.extend(relativeTime);


// Slide 动画组件
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function PhotoDialog({ open, onClose }) {
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const [swiperOpen, setSwiperOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [sampleData, setSampleData] = useState(null);
  const [photo, setPhoto] = useState(null);
  const [openSearch, setOpenSearch] = useState(false);
  const [chipTitle, setChipTitle] = useState(null);
  const [player, setPlayer] = useState("");
  // 全局播放器状态
  const [openPlayer, setOpenPlayer] = useState(false);
  const [playerUrl, setPlayerUrl] = useState("");
  const [playerTitle, setPlayerTitle] = useState("");
  const [playerThumbnail, setPlayerThumbnail] = useState("");
  const [playerVideoId, setPlayerVideoId] = useState("");
  // ✅ 新增提示框状态
  const [toastOpen, setToastOpen] = useState(false);
  const { userData } = useUser();
  const [favorToastOpen, setFavorToastOpen] = useState(false);
  const [openType, setOpenType] = useState(false);
  // ✅ 新增 cardInfo 动态状态
  const [cardInfo, setCardInfo] = useState([]);
  const [cardPage, setCardPage] = useState(1); // 新增：分页页码
  const scrollRef = useRef(null); // 新增：滚动容器 ref
  const [loadingMore, setLoadingMore] = useState(false); // 新增：防止重复加载
  const [openSaveTips, setOpenSaveTips] = useState(false);
  const [openTop, setOpenTop] = useState(false);
  const [category, setCategory] = useState("周排行榜"); // 你想展示的分类
  const [openTutorial, setOpenTutorial] = useState(false);

  // 修改 handleSave 函数
  const handleSave = () => {
    if (userData) {
      window.Telegram.WebApp.ready();
      const tel_user = window.Telegram.WebApp.initDataUnsafe || {};
      if (Object.keys(tel_user).length === 0) return;
      const param = parseStartAppParam(tel_user);
      const url = `${DOMAIN}ywyminiappbot/addFavor?userid=${userData.userid}&vid=${param.photo}`;
      setFavorToastOpen(true);
      fetch(url)
        .then((res) => res.json())
        .then(() => {
          // ✅ 收藏成功后弹出提示框
        })
        .catch(() => {
          // 请求失败时也可选地提示错误
          setToastOpen(true);
        });
    }
  };

  // ✅ 新增：滚动到底部加载下一页
  useEffect(() => {
    const handleScroll = () => {
      if (!scrollRef.current || loadingMore) return;
      const { scrollTop, clientHeight, scrollHeight } = scrollRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 50) { // 距底50px触发
        setLoadingMore(true);
        const param = parseStartAppParam(window.Telegram.WebApp.initDataUnsafe || {});
        const blogger = photo?.author?.name || "";
        const videoid = photo?.id || "";
        const nextPage = cardPage + 1;
        fetch(`${DOMAIN}player/getKeywordVideos?keyword=${blogger}&page=${nextPage}&size=5&videoid=${videoid}&keyword2=店长推荐`)
          .then(res => res.json())
          .then(data => {
            const list = data.map(item => ({
              id: item.id,
              image: `${DOMAIN}miniapp/${item.thumbnail}.tb.jpg`,
              caption: item.title,
              duration: convertSecondsToTime(Number(item.duration)),
              views: formatViews(item.views),
              date: dayjs(item.date * 1000).fromNow(),
            }));
            setCardInfo(prev => [...prev, ...list]);
            setCardPage(nextPage);
            setLoadingMore(false);
          })
          .catch(err => {
            console.error("getCardInfo error:", err);
            setLoadingMore(false);
          });
      }
    };
    const container = scrollRef.current;
    container?.addEventListener("scroll", handleScroll);
    return () => container?.removeEventListener("scroll", handleScroll);
  }, [cardPage, photo, loadingMore]);


  useEffect(() => {
    if (window.Telegram && window.Telegram.WebApp) {
      window.Telegram.WebApp.ready();
      const tel_user = window.Telegram.WebApp.initDataUnsafe || {};
      if (Object.keys(tel_user).length === 0) return;


      const param = parseStartAppParam(tel_user)
      if (param && param.photo) {
        fetch(`${DOMAIN}ywyminiappbot/getPlayer`)
          .then(response => response.json())
          .then(data => setPlayer(data[0]?.url || ""));

        fetch(`${DOMAIN}videoDetail/getVideo?id=${param.photo}`)
          .then((response) => response.json())
          .then((data) => {
            const duration = convertSecondsToTime(data.data[0].duration)
            const imageMedias = data.data[0].medias.filter(media => media.type === "image");

            // 第一个 image 的 fileid
            const firstImageFileId = imageMedias[0]?.fileid;

            // 第二个 image 的 fileid
            const secondImageFileId = imageMedias[1]?.fileid;

            // 提取博主名，并去掉开头的 #
            const blogger = extractBloggerPhoto(data.data[0].caption)
            console.log(blogger)
            const medias = data.data[0].medias;
            getCardInfo(blogger, param.photo)

            // 提取所有图片 fileid，并拼接成 URL
            const imageUrls = medias
              .filter(media => media.type === "image")
              .map(media => `${DOMAIN}miniapp/${media.fileid}.tb.jpg`);

            const data2 = {
              album: [
                {
                  image: `${DOMAIN}miniapp/${firstImageFileId}.tb.jpg`,
                  text: data.data[0].caption,
                  duration,
                  r2: data.data[0].r2,
                  id: data.data[0].id,
                  type: data.data[0].type,
                  thumbnail: secondImageFileId,
                  author: {
                    name: blogger,
                    avatar: `${DOMAIN}miniapp/${secondImageFileId}.tb.jpg`,
                    avatar2: `${DOMAIN}miniapp/${firstImageFileId}.tb.jpg`,
                    avatar3: `${DOMAIN}miniapp/${secondImageFileId}.jpg`,
                  },
                },
              ],
              albumImages: imageUrls
            };
            setSampleData(data2);
            setPhoto(data2.album[0]); // ✅ 保证 photo 是 album 内第一个对象

          })
      }
    }
  }, []);

  // ✅ 动态获取 cardInfo 数据
  const getCardInfo = (blogger, videoid) => {
    fetch(`${DOMAIN}player/getKeywordVideos?keyword=${blogger}&page=${1}&size=${5}&videoid=${videoid}&keyword2=店长推荐`)
      .then(res => res.json())
      .then(data => {
        const list = data.map(item => {
          return {
            id: item.id,
            image: `${DOMAIN}miniapp/${item.thumbnail}.tb.jpg`,
            caption: item.title,
            duration: convertSecondsToTime(Number(item.duration)),
            views: formatViews(item.views),
            date: dayjs(item.date * 1000).fromNow(),
          };
        });
        setCardInfo(list);
      })
      .catch(err => console.error("getCardInfo error:", err));
  };

  const handleSearch = (keyword) => {
    setChipTitle(keyword);
    setOpenSearch(true);
  };

  // ✅ 完善的 handleChangeVideoid
  const handleChangeVideoid = (videoid, thumbnail) => {
    setOpenPlayer(false);

    setTimeout(() => {
      // 更新 videoid
      setPlayerVideoId(videoid);
      setPlayerThumbnail(thumbnail)
      setOpenPlayer(true);      // 重新打开 Dialog
    }, 300);
  };

  const handleOpenPlayer = () => {
    if (!photo?.r2) {
      // 打开提示框
      setToastOpen(true);
      return;
    }
    setPlayerVideoId(photo.id);
    setOpenPlayer(true);
    setPlayerThumbnail(photo.thumbnail)

  }

  // ✅ 完善的 handleChangeVideoid
  const handleOpenCard = (id) => {


    setOpenPlayer(false);
    setPlayerVideoId(id);
    setOpenPlayer(true);
  };

  const handlePlayTG = () => {
    const type = photo.type === 11 ? "tv" : "vid";
    const url = `${player}?start=${type}_${photo.id}`;

    // 判断是否在 Telegram Mini App 内
    const isTelegramMiniApp = !!(window.Telegram && window.Telegram.WebApp);

    if (isTelegramMiniApp) {
      // Telegram Mini App 内使用 openTelegramLink
      window.Telegram.WebApp.openTelegramLink(url);
    } else {
      // 普通浏览器/非 Telegram Mini App 使用 window.open
      window.open(url, "_blank");
    }
  }



  return (
    <>
      <TutorialVideoDialog
        open={openTutorial}
        onClose={() => setOpenTutorial(false)}
        videoUrl={`${R2DOMAIN}/24e9f8e76eab46b9a8c8cecafb3caded.m3u8`} // ✅ 你的 m3u8 视频地址
      />
      <TopVideoDialog
        openMovies={openTop}
        setOpenMovies={setOpenTop}
        chipTitle={"热播榜"}
        matches={matches}
      />
      <SaveTipsDialog open={openSaveTips} onClose={() => setOpenSaveTips(false)} />
      <GameCategoryDialog open={openType} setOpenType={setOpenType} />
      {/* ✅ 提示框 */}
      <CenterSnackbar
        open={toastOpen}
        onClose={() => setToastOpen(false)}
        message="在线版本正在等待管理员上传，请稍后再来或是先观看电报版本"
      />


      {/* ✅ 收藏成功提示框 */}
      <CenterSnackbar
        open={favorToastOpen}
        onClose={() => setFavorToastOpen(false)}
        message="收藏成功，点击右上角返回首页查看"
      />
      <SearchDialog
        openSearch={openSearch}
        setOpenSearch={setOpenSearch}
        chipTitle={chipTitle}
      />
      <VideoPlayerDialog
        open={openPlayer}
        onClose={() => setOpenPlayer(false)}
        url={playerUrl}
        title={playerTitle}
        videoid={playerVideoId}
        thumbnail={playerThumbnail}
        setOpenPlayer={setOpenPlayer}
        handleChangeVideoid={handleChangeVideoid}
        player={player}
      />
      {/* 主 Dialog */}
      <Dialog
        open={open}
        onClose={onClose}
        TransitionComponent={Transition}
        fullWidth
        maxWidth={false}
        sx={{
          "& .MuiDialog-container": {
            alignItems: "flex-end", // 👈 底部贴边
          },
          "& .MuiDialog-paper": {
            width: "100vw",         // 👈 强制全宽（关键）
            maxWidth: "100vw",
            margin: 0,
          },
        }}
        PaperProps={{
          sx: {
            height: "58vh",
            maxHeight: "58vh",
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            bgcolor: "rgba(255,255,255,0.2)",
            backdropFilter: "blur(4px)",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >


        {/* 顶部 AppBar */}
        <AppBar
          position="absolute"
          elevation={0}
          sx={{
            top: 0,
            left: 0,
            right: 0,
            bgcolor: "rgba(255,255,255,0)",
            paddingLeft: 2,
            paddingRight: 2,
          }}
        >
          <Toolbar sx={{ justifyContent: "space-between" }}>
            <Typography variant="h6" sx={{ fontWeight: 600, color: "#000" }}>

            </Typography>
            <IconButton
              edge="end"
              onClick={onClose}
              sx={{
                p: 1,
                bgcolor: "rgba(255,255,255,0.6)", // 半透明底板
                backdropFilter: "blur(6px)",      // 轻微毛玻璃
                borderRadius: "50%",              // 圆形
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                "&:hover": {
                  bgcolor: "rgba(255,255,255,0.8)",
                },
                "&:active": {
                  transform: "scale(0.95)",
                },
              }}
            >
              <CloseIcon sx={{ color: "#000", fontSize: 28 }} />
            </IconButton>

          </Toolbar>
        </AppBar>

        {/* 滚动内容 */}
        <Box ref={scrollRef} sx={{ flex: 1, overflowY: "auto", px: 1, py: 0, mt: 1 }}>
          {/* 图片区 */}
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: "50vh",
              mb: 3,
              borderRadius: 2,
              overflow: "hidden",
            }}
          >


            {/* 浮层 */}
            {photo && (
              <Box
                sx={{
                  position: "absolute",
                  bottom: 3,
                  top: 30,
                  left: 3,
                  right: 3,
                  p: 3,
                  borderRadius: 3,
                  bgcolor: "rgba(255,255,255,0.5)",
                  color: "#000",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255,255,255,0.5)",
                  boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                }}
              >
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  mb={1}
                  justifyContent="space-between"
                >
                  <Stack

                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{
                      cursor: "pointer",
                      px: 1.5,
                      py: 0.6,
                      borderRadius: 2,
                      backgroundColor: "rgba(255,255,255,0.15)",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                      transition: "all 0.2s ease",
                      "&:active": { transform: "scale(0.97)", boxShadow: "0 1px 4px rgba(0,0,0,0.2)" },
                      "&:hover": { backgroundColor: "rgba(255,255,255,0.25)", boxShadow: "0 3px 8px rgba(0,0,0,0.2)" },
                    }}
                    onClick={() => handleSearch(photo.author?.name)}
                  >

                    <SmartAvatar photo={photo} />




                    <Typography variant="subtitle1" fontWeight={500} fontSize={14}>
                      {photo.author?.name}
                    </Typography>
                  </Stack>

                  {/* 相册缩略框 */}
                  {sampleData && (
                    <Box
                      sx={{
                        position: "relative",
                        width: 60,
                        height: 60,
                        borderRadius: 2,
                        overflow: "hidden",
                        border: "1px solid rgba(0,0,0,0.2)",
                        cursor: "pointer",
                        flexShrink: 0,
                      }}
                      onClick={() => setSwiperOpen(true)}
                    >
                      <Box
                        component="img"
                        src={sampleData.album[0].image}
                        alt="album thumbnail"
                        sx={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          transition: "transform 0.3s",
                          "&:hover": { transform: "scale(1.05)" },
                        }}
                        onError={(e) => {
                          // 图片加载失败时换成备用图
                          const fallbackUrl = photo.image.replace(".tb.jpg", ".jpg");
                          if (e.target.src !== fallbackUrl) {
                            e.target.src = fallbackUrl;
                          } else {
                            // 如果连.jpg也加载失败，可以给一个默认占位图
                            e.target.src = `${DOMAIN}miniapp/default.jpg`;
                          }
                        }}
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          bgcolor: "rgba(0, 0, 0, 0.7)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#fff",
                          transition: "all 0.3s ease",
                          opacity: 0.85,
                          "&:hover": { bgcolor: "rgba(0,0,0,0.8)", opacity: 1 },
                        }}
                      >

                        <Typography variant="caption" sx={{ fontSize: 12 }}>
                          相册
                        </Typography>
                      </Box>
                    </Box>
                  )}
                </Stack>

                {/* 视频时长 */}
                <Typography
                  variant="body2"
                  mb={1}
                  sx={{
                    color: "text.secondary",
                    fontSize: "0.75rem",
                    lineHeight: 1.4,
                  }}
                >
                  视频时长：{photo.duration}
                </Typography>

                {/* 描述文字 */}
                <Typography
                  variant="body2"
                  mb={2}
                  sx={{
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    color: "text.secondary",
                    lineHeight: 1.6,
                    fontSize: "0.85rem",
                  }}
                >
                  {photo.text}
                </Typography>

                {/* 按钮区域保持原样 */}
                <Box sx={{ mt: 2 }}>
                  {/* 第一行按钮 */}
                  <Stack direction="row" spacing={1} sx={{ mb: 1.5 }}>
                    <Button
                      variant="contained"
                      startIcon={<TelegramIcon sx={{ fontSize: 18 }} />}
                      onClick={handlePlayTG}
                      sx={{
                        textTransform: "none",
                        borderRadius: 14,
                        fontWeight: 500,
                        fontSize: 12,
                        minHeight: 32,
                        color: "#fff",
                        flex: 1,
                        py: 0.25,
                        background:
                          "linear-gradient(135deg, rgba(0,122,255,0.95), rgba(10,132,255,0.9))",
                        boxShadow: "0 2px 6px rgba(0,122,255,0.25)",
                        "&:hover": {
                          background:
                            "linear-gradient(135deg, rgba(0,122,255,1), rgba(10,132,255,1))",
                        },
                      }}
                    >
                      电报看
                    </Button>

                    <Button
                      variant="outlined"
                      startIcon={<PlayArrowIcon sx={{ fontSize: 18 }} />}
                      onClick={handleOpenPlayer}
                      sx={{
                        textTransform: "none",
                        borderRadius: 14,
                        fontWeight: 500,
                        fontSize: 12,
                        minHeight: 32,
                        flex: 1,
                        py: 0.25,
                        color: "#fff",
                        borderColor: "rgba(255,255,255,0.6)",
                        background: "rgba(100,100,100,0.3)",
                        backdropFilter: "blur(8px)",
                        "&:hover": {
                          background: "rgba(255,255,255,0.25)",
                        },
                      }}
                    >
                      在线看
                    </Button>

                    <Button
                      variant="outlined"
                      onClick={() => handleSearch(photo.author?.name)}
                      sx={{
                        textTransform: "none",
                        borderRadius: 14,
                        fontWeight: 500,
                        fontSize: 12,
                        minHeight: 32,
                        flex: 1,
                        py: 0.25,
                        color: "#fff",
                        borderColor: "rgba(255,255,255,0.6)",
                        background: "rgba(100,100,100,0.3)",
                        backdropFilter: "blur(8px)",
                        "&:hover": {
                          background: "rgba(255,255,255,0.25)",
                        },
                      }}
                    >
                      全集列表
                    </Button>
                  </Stack>
                </Box>
              </Box>
            )}
          </Box>


        </Box>
      </Dialog>

      {/* Swiper 相册弹层 */}
      <Dialog
        fullScreen
        open={swiperOpen}
        onClose={() => setSwiperOpen(false)}
        TransitionComponent={Transition}
        PaperProps={{ sx: { bgcolor: "rgba(0,0,0,0.9)" } }}
      >
        <IconButton
          onClick={() => setSwiperOpen(false)}
          sx={{ position: "absolute", top: 20, right: 20, color: "#fff", zIndex: 99 }}
        >
          <CloseIcon />
        </IconButton>

        {sampleData && (
          <Swiper
            spaceBetween={30}
            slidesPerView={1}
            onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
            style={{ width: "100%", height: "100%" }}
          >
            {sampleData.albumImages.map((img, i) => (
              <SwiperSlide key={i}>
                <Box
                  component="img"
                  src={img}
                  alt={`slide-${i}`}
                  sx={{ width: "100%", height: "100%", objectFit: "contain", backgroundColor: "black" }}
                  onError={(e) => {
                    // 图片加载失败时换成备用图
                    const fallbackUrl = photo.image.replace(".tb.jpg", ".jpg");
                    if (e.target.src !== fallbackUrl) {
                      e.target.src = fallbackUrl;
                    } else {
                      // 如果连.jpg也加载失败，可以给一个默认占位图
                      e.target.src = `${DOMAIN}miniapp/default.jpg`;
                    }
                  }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        )}

        {sampleData && (
          <Box
            sx={{
              position: "absolute",
              bottom: 20,
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "rgba(0,0,0,0.5)",
              color: "#fff",
              px: 2.5,
              py: 0.5,
              borderRadius: 20,
              fontSize: "0.9rem",
              letterSpacing: 0.5,
              backdropFilter: "blur(4px)",
              zIndex: 90,
              minWidth: 70,
              textAlign: "center",
            }}
          >
            {activeIndex + 1} / {sampleData.albumImages.length}
          </Box>
        )}
      </Dialog>
    </>
  );
}

const SmartAvatar = ({ photo }) => {
  const [imgSrc, setImgSrc] = useState(photo.author?.avatar);

  useEffect(() => {
    // 当 author 改变时，重置主图
    setImgSrc(photo.author?.avatar);
  }, [photo.author?.avatar]);

  return (
    <Avatar
      src={imgSrc}
      sx={{ border: "1px solid rgba(255,255,255,0.4)" }}
      onError={() => {
        if (photo.author?.avatar2 && imgSrc !== photo.author.avatar2) {
          setImgSrc(photo.author.avatar2); // 切换到备用图
        } else {
          setImgSrc(photo.author.avatar3); // 最终备用图
        }
      }}
    />
  );
};

export default PhotoDialog;


function CenterSnackbar({ open, onClose, message, duration = 3000 }) {
  return (
    <Snackbar
      open={open}
      onClose={onClose}
      autoHideDuration={duration}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      ContentProps={{
        sx: {
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "rgba(0,0,0,0.8)",
          color: "#fff",
          fontSize: 14,
          px: 3,
          py: 1.5,
          borderRadius: 2,
          textAlign: "center",
          boxShadow: "0 2px 12px rgba(0,0,0,0.4)",
        },
      }}
      message={message}
    />
  );
}
